import moment from 'moment';
import { useEffect, useState } from 'react';
import { Box, ConfirmPopup } from '~/commonComponents';
import { ModalOrder, useModal } from '~/components/ModalQueue';
import { useUserSelector } from '~/hooks';
import GreatNewsCalendar from '~/images/GreatNewsCalendar.svg';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

interface IChargeTimelineDaysPopupProps {
  screenName: string;
}

export function ChargeTimelineDaysPopup({ screenName }: IChargeTimelineDaysPopupProps) {
  const user = useUserSelector();
  const [showPopup, setShowPopup] = useState(false);
  const chargeTimelineDays = RemoteConfigUtils.getChargeTimelineDays();
  const chargeTimelineDaysPopupKey = `chargeTimelinePopup-${user?.id}-${screenName}-updated`;
  const chargeTimelineUserCreationDate = RemoteConfigUtils.getChargeTimelineUserCreationDate();

  const getStorage = () => {
    const chargeTimelinePopup = localStorage.getItem(chargeTimelineDaysPopupKey);

    if (chargeTimelinePopup === null) {
      setShowPopup(true);
    }
  };

  const setStorage = () => {
    localStorage.setItem(chargeTimelineDaysPopupKey, 'false');
    setShowPopup(false);
  };

  const handleClose = () => {
    setStorage();
  };

  useEffect(() => {
    getStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const { isActive } = useModal({
    id: ModalOrder.CHARGE_TIMELINE_DAYS_POPUP,
    condition: showPopup,
  });

  if (!user) {
    return null;
  }

  const isPreApproved = user?.is_pre_approved;
  const isNewOffice = chargeTimelineUserCreationDate
    ? moment(user.created_at).isAfter(moment(chargeTimelineUserCreationDate))
    : true;

  // Don't show if office is pre-approved OR is a new office
  if (isPreApproved || isNewOffice) {
    return null;
  }

  return (
    isActive &&
    showPopup &&
    chargeTimelineDays > 0 &&
    user.mdbChargeTimelineDays > 0 &&
    chargeTimelineDays === user.mdbChargeTimelineDays && (
      // @ts-expect-error missing type
      <ConfirmPopup
        dataCy="charge-timeline-popup"
        rightButtonDataCy="charge-timeline-close-button"
        Icon={() => (
          <Box marginBottom={16}>
            <img src={GreatNewsCalendar} alt="charge timeline image" />
          </Box>
        )}
        modalStyle={{
          width: 532,
        }}
        title="Book Now, Pay Later!"
        description={
          <>
            Great news! Your charge timeline just got a major upgrade.
            <br />
            <br />
            Professional pay will only be collected {chargeTimelineDays} days before the shift,
            compared to 28 days previously. This gives your office more room to plan ahead, secure
            coverage in advance, and manage your cash flow.
            <br />
            <br />
            For questions, contact your GoTu Account Manager.
          </>
        }
        descriptionStyle={{
          marginBottom: 32,
        }}
        closePopup={handleClose}
        rightButtonText="Close"
        rightButtonAction={handleClose}
      />
    )
  );
}
